import { FC } from 'react'

export const Modal: FC = ({ children }) => (
  <div className="fixed top-0 left-0 flex justify-center items-center w-screen h-screen bg-modal-background z-50">
    <div className="rounded-10 p-42 bg-white w-[800px] max-h-[90%] overflow-scroll">
      {children}
    </div>
  </div>
)
